var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDDE00;}\n\t.st1{fill:#3C2D0C;}\n\t.st2{fill:#E78C19;}\n\t.st3{fill:#EFB99D;}\n\t.st4{fill:#FBFBFB;}\n\t.st5{fill:#E72D36;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.1,311.5c0,0-22.8,28.7-15.2,158.6c0,0-49.8,127.4-32.9,192.4s82.7,61.6,82.7,61.6s105.5,92.8,186.5,11 S379.7,336,379.7,336l-18.6-109.7c0,0-20.3,16-17.7,121.5S302.1,379,302.1,379L226.1,311.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.6,426.3l-27.8,78.5l-10.1,54.8c0,0-34.6,122.4,108,120.7c0,0,111.4,99.6,183.9,32.9l19.4-21.1l33.8-52.3 l55.7-166.2c0,0-17.7-113.9-129.9-161.2c0,0-9.3-5.1-26.2,1.7c0,0-46.4-104.6-75.9-92c0,0-25.3,13.5-3.4,116.4l-39.7,17.7 c0,0-43.4-82.2-83.5-65.8C201.7,305.6,234.6,426.3,234.6,426.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.9,273.5l3.4,45.6c0,0,2.5,26.2,30.4,16.9c7.9-2.6,14.8-8.1,14.1-17.1c-0.5-6.7-5.2-12.8-8.3-18.6 c-5.7-10.9-10.3-22.4-17-32.8c-3.4-5.3-10.4-17.2-18.3-15.8C383.1,251.6,377.3,249.9,378.9,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.9,324.7c0.5-0.3,11.9-14.7,35.4,20.1c23.6,34.8,21.2,30.2,21.2,30.2s12.7,13.9-13.3,31.8 c-5.7,4.2-11.8,7.6-18.4,10.3c-4.1,1.6-8.4,2.5-12.8,2.4c-4.9-0.2-7.1-2.8-8.4-7.4c-4-15.2-8.5-30.3-10.8-45.9 C248.3,354.5,244.8,332.6,256.9,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M530.9,394.8c0,8.3-12.1,15-27,15c-14.9,0-27-6.7-27-15c0-8.3,12.3-20.5,27.3-20.5S530.9,386.6,530.9,394.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4925 -0.8703 0.8703 0.4925 -209.6993 540.6487)",
    className: "st4",
    cx: 358.8,
    cy: 450.1,
    rx: 29.5,
    ry: 18.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M413.5,527.9l73.8-38.4c0,0,92-48.1,114.3-11s0,93.7,0,93.7s-9.7,66.2-77.2,72.1l-36.3,5.1l-46.4,1.3 c0,0-74.7,4.2-129.5-36.3l-17.3-21.1c0,0-35-48.1-10.5-82.7s108,19,108,19S403.8,535.5,413.5,527.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 581,
    cy: 318.7,
    r: 17.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 541.7,
    cy: 275.2,
    r: 17.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 478.9,
    cy: 261.3,
    r: 17.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M492.8,135.6c3.8,52.3-3.8,99.6-16.5,99.6s-29.5-51-29.5-99.6c0-20,10.5-23.2,23.2-23.2 C482.7,112.4,491.3,115.6,492.8,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M610.2,168.2c-19.3,48.8-46.6,88.1-58.1,82.5c-11.4-5.5-4.4-58.8,16.6-102.5c8.7-18,19.5-16.3,31-10.8 C611.2,143,617.5,149.6,610.2,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M694.1,263.1c-42.5,30.8-86.6,49.3-93.3,38.5c-6.7-10.8,27.8-52,69.1-77.6c17-10.6,25.3-3.3,32,7.5 C708.5,242.3,710.3,251.3,694.1,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,476.5c-1.6,0.1-3.1,0.3-4.6,0.6c0.2,0.5,0.3,1.1,0.3,1.7c0,5.4-8.4,9.8-19,10.1c-0.1,0.5-0.1,0.9-0.1,1.4 c0.5,6.5,11.8,11,25.2,9.9c13.4-1,23.9-7.2,23.4-13.7C434.7,479.9,423.4,475.4,410,476.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.3,453.4c-1.6,0.1-3.1,0.3-4.6,0.6c0.2,0.5,0.3,1.1,0.3,1.7c0,5.4-8.4,9.8-19,10.1c-0.1,0.5-0.1,0.9-0.1,1.4 c0.5,6.5,11.8,11,25.2,9.9c13.4-1,23.9-7.2,23.4-13.7C528,456.8,516.7,452.3,503.3,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.9,480.7c0,0-37,10.8-34.8,31.6c2.2,20.9,46.8,31.6,46.8,31.6s12,4.7,19-6.6c7-11.4,17.1-26.9,14.2-49 C579.2,488.3,578.2,471.8,533.9,480.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonkIcon);
export default __webpack_public_path__ + "static/media/bonk_icon.8a8d4dfd24ece5f67fdbc7d03f45472b.svg";
export { ForwardRef as ReactComponent };